// Models a controlling individual for the purposes of KYB onboarding. This model
// will be used for UI involving the addition/editting of controlling individuals.

import { Address } from '@square/dashboard-protos/models/squareup/connect/v2/resources/address';
import { ConnectApiDate } from '@banking/api/utils/date-format';
import { KybPersonRole, KybPersonaName, KybPersona } from '@square/dashboard-protos/models/squareup/bbqualifier/kyb_model';
import { GlobalAddress } from '@square/dashboard-protos/models/squareup/common/location';
export let GovernmentIdType = /*#__PURE__*/function (GovernmentIdType) {
  GovernmentIdType[GovernmentIdType["SSN"] = 0] = "SSN";
  return GovernmentIdType;
}({});
export function managerIndividual(array) {
  return array.find(individual => individual.isManager);
}
export function accountOwnerIndividual(array) {
  return array.find(individual => individual.isAccountOwner);
}
export function ownerIndividuals(array) {
  return array.filter(individual => individual.isSignificantOwner);
}
export function fromSfsApiControllingIndividual(controllingIndividual) {
  const individual = {
    id: controllingIndividual.id,
    isManager: controllingIndividual.isManager,
    isSignificantOwner: controllingIndividual.hasSignificantOwnership,
    givenName: controllingIndividual.givenName,
    surname: controllingIndividual.surname,
    address: controllingIndividual.address,
    birthDate: ConnectApiDate.parse(controllingIndividual.birthDate),
    governmentId: {
      type: GovernmentIdType.SSN,
      serialNumber: controllingIndividual.ssn?.last4
    }
  };
  return individual;
}
export function fromBbQualifierApiKybPersona(kybPersona) {
  const individual = {
    id: kybPersona.legalEntityToken,
    isManager: kybPersona.roles.includes(KybPersonRole.BUSINESS_MANAGER),
    isAccountOwner: kybPersona.roles.includes(KybPersonRole.SQ_ACCOUNT_HOLDER),
    isSignificantOwner: kybPersona.roles.includes(KybPersonRole.BENEFICIAL_OWNER),
    givenName: kybPersona.name?.firstName ?? '',
    middleName: kybPersona.name?.middleName ?? '',
    surname: kybPersona.name?.lastName ?? '',
    address: globalToConnectAddress(kybPersona.personalAddress),
    birthDate: kybPersona.dateOfBirth,
    governmentId: {
      type: GovernmentIdType.SSN,
      serialNumber: kybPersona.nationalIdSummary?.lastFour
    }
  };
  return individual;
}
export function toBbQualifierApiKybPersona(individual, countryCode = 840) {
  const name = KybPersonaName.create({
    firstName: individual.givenName,
    middleName: individual.middleName,
    lastName: individual.surname
  });
  const roles = [...(individual.isAccountOwner ? [KybPersonRole.SQ_ACCOUNT_HOLDER] : []), ...(individual.isManager ? [KybPersonRole.BUSINESS_MANAGER] : []), ...(individual.isSignificantOwner ? [KybPersonRole.BENEFICIAL_OWNER] : [])];
  return KybPersona.create({
    name,
    roles,
    dateOfBirth: individual.birthDate,
    fullNationalId: individual.governmentId.value || undefined,
    nationalIdSummary: individual.governmentId.serialNumber && !individual.governmentId.value ? KybPersona.NationalIdentificationNumberSummary.create({
      lastFour: individual.governmentId.serialNumber
    }) : undefined,
    personalAddress: connectToGlobalAddress(individual.address, countryCode),
    legalEntityToken: individual.id
  });
}

// TODO @jmah: Move these helpers to a util
function connectToGlobalAddress(address, countryCode) {
  return GlobalAddress.create({
    addressLine1: address.addressLine1,
    addressLine2: address.addressLine2,
    locality: address.locality,
    administrativeDistrictLevel1: address.administrativeDistrictLevel1,
    postalCode: address.postalCode,
    countryCode
  });
}
export function globalToConnectAddress(address) {
  return Address.create({
    addressLine1: address.addressLine1,
    addressLine2: address.addressLine2,
    locality: address.locality,
    administrativeDistrictLevel1: address.administrativeDistrictLevel1,
    postalCode: address.postalCode
  });
}